import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContestationAi } from '@app/models';
import { Observable } from 'rxjs';
import { BaseServiceClass } from './baseService.service';

@Injectable({ providedIn: 'root' })
export class ContestationAiService extends BaseServiceClass<ContestationAi> {
  constructor(protected httpService: HttpClient) {
    super(httpService, '/contestation-ai');
  }

  public patch(obj: any, id: number): Observable<any> {
    return this.httpService.patch(`${this.entity_url}/${id}`, obj);
  }

  // ${this.entity_url}
  public getVariables(): Observable<any> {
    return this.httpService.get(`${this.entity_url}/variables`);
  }

  public preview(
    contestationGenAiId: number,
    body: { interactionId: number; monitorInteractionItemId: number }
  ): Observable<any> {
    return this.httpService.post(
      `${this.entity_url}/${contestationGenAiId}/preview`,
      body
    );
  }
}
